import React from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import { ZoomIn, ZoomOut } from "@mui/icons-material";

const GanttToolbar = ({ onZoomIn, onZoomOut, statusText }) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
				gap: 2,
				p: 1,
				borderBottom: "1px solid #e0e0e0",
				backgroundColor: "#fafafa",
			}}
		>
			<ButtonGroup size="medium" variant="outlined">
				<Button onClick={onZoomIn} startIcon={<ZoomIn />} title="Zoom In">
					Zoom In
				</Button>
				<Button onClick={onZoomOut} startIcon={<ZoomOut />} title="Zoom Out">
					Zoom Out
				</Button>
			</ButtonGroup>

			{statusText && (
				<Box sx={{ fontSize: "0.875rem", color: "#666" }}>{statusText}</Box>
			)}
		</Box>
	);
};

export default GanttToolbar;
